<template>
  <header class="app-header" :class="{ isMobile: isMobile }">
    <v-overlay style="z-index: 1" :value="drawer"></v-overlay>
    <LibHeaderAccessibilityPopup v-model="isOpenPopupWcag" />
    <div class="bar-top content-padd-x" v-if="!isMobile">
      <div class="bar-content">
        <div class="bar-left">
          <LibBtnSimple
            text="Portal eBudownictwo"
            icon="mdi-arrow-left-thin"
            color="#fff"
            href="https://e-budownictwo.gunb.gov.pl/"
            underline
          />
          <LibHeaderSelectNav class="ml-4" />
        </div>
        <div class="bar-right">
          <LibBtnSimple
            text="Ustawienia dostępności"
            icon="mdi-human"
            color="#fff"
            underline
            @click.native="isOpenPopupWcag = true"
          />
        </div>
      </div>
    </div>

    <div class="bar-main content-padd-x">
      <div class="bar-content">
        <div class="logo-cont">
          <a href="/">
            <img class="logo" alt="Logo EDB" src="/img/logo-edb.svg" />
          </a>
        </div>
        <nav class="nav">
          <v-app-bar-nav-icon
            @click.stop="drawer = !drawer"
            color="primaryBlue"
            v-if="isMobile"
            class="btn-drawer"
          ></v-app-bar-nav-icon>
          <v-navigation-drawer
            v-model="drawer"
            v-if="isMobile"
            app
            temporary
            right
            hide-overlay
          >
            <v-list dense nav>
              <v-list-item link>
                <v-list-item-icon class="mr-4">
                  <v-icon>mdi-human</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title @click="openWcagDialog">
                    Ustawienia dostępności
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
          </v-navigation-drawer>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import LibBtnSimple from "../common/LibBtnSimple.vue";
import LibHeaderSelectNav from "./LibHeaderSelectNav.vue";
import LibHeaderAccessibilityPopup from "./LibHeaderAccessibilityPopup.vue";
export default {
  name: "LibHeader",
  components: {
    LibBtnSimple,
    LibHeaderSelectNav,
    LibHeaderAccessibilityPopup
  },

  props: {},
  data() {
    return {
      drawer: false,
      group: null,
      isOpenPopupWcag: false
    };
  },
  methods: {
    login() {
      const props = this.$router.resolve({ name: "Account" });
      let path = window.location.origin.split(/[?#]/)[0];
      if (path.endsWith("/")) path = path.slice(0, -1);
      this.$store.dispatch("auth/login", { redirectUri: path + props.href });
    },
    openWcagDialog() {
      this.isOpenPopupWcag = true;
      this.drawer = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.app-header {
  z-index: 3;
}
.bar-top {
  position: relative;
  background: var(--c-primary);
  color: #fff;
  height: 48px;
  .bar-left,
  .bar-right {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
  }
  .bar-left {
    position: relative;
    left: -21px;
  }
  .bar-right {
    position: relative;
    right: -12px;
  }
  .bar-content {
    max-width: var(--site-width);
    // max-width: calc(var(--site-width) + 42px);
    // padding-right: 8px;
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
.bar-main {
  height: 120px;
  background: #fff;
  border-bottom: 1px solid #e0e0e0;

  .logo-cont {
    height: 100%;
    display: flex;
    align-items: center;
  }
  .logo {
    width: 140px;
    display: block;
  }
  .bar-content {
    max-width: var(--site-width);
    height: 100%;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .nav {
    display: flex;
    align-items: center;
  }
}

.isMobile {
  &.app-header {
    position: sticky;
    top: 0;
  }
  .btn-drawer {
    right: -8px;
  }
  .bar-main {
    height: 64px;
    // box-shadow: 0px 0px 27px 3px rgba(51, 51, 153, 0.1);
    box-shadow: 0px 0px 27px 3px rgba(0, 102, 255, 0.15);
    .logo {
      width: 80px;
    }
  }
}
</style>
